import React from 'react';
import cn from 'classnames';

import { UserLoginType } from 'client/types';
import { useOnClickOutside } from 'client/hooks';
import { useTranslation, useAppDispatch, useGAEventCommonProps } from 'client/hooks';
import { setFormByUserType } from 'client/redux/login';
import { setIsShowFooterPopUpOverlay } from 'client/redux/ui';
import { analytics } from 'client/utils';
import Icon from '../../../../Icon';

import css from './PopUpToLogin.module.scss';

interface Props {
  className?: string;
  closePopup: () => void;
  toLoginPopUpText: 'emotions' | 'speaking' | '';
}

const PopUpToLogin: React.FC<Props> = (props) => {
  const { className = '', toLoginPopUpText, closePopup } = props;
  const { translate } = useTranslation('popUps');
  const dispatch = useAppDispatch();
  const { common } = useGAEventCommonProps();
  const popUpWrapperRef = React.useRef<HTMLDivElement>(null);

  const renderText = () => {
    if (toLoginPopUpText === 'emotions') return translate('toLoginPopUp.emotionsActionText');
    if (toLoginPopUpText === 'speaking') return translate('toLoginPopUp.speakingActionText');
    return '';
  };

  const close = () => {
    analytics.gtag.event('audio_chat_content_click', {
      ...common,
      text_clicked: translate('toLoginPopUp.cancelBtn'),
    });
    closePopup();
    dispatch(setIsShowFooterPopUpOverlay(false));
  };

  const onOkClick = () => {
    analytics.gtag.event('audio_chat_content_click', {
      ...common,
      text_clicked: translate('toLoginPopUp.okBtn'),
    });
    closePopup();
    dispatch(setIsShowFooterPopUpOverlay(false));
    dispatch(setFormByUserType(UserLoginType.regular));
  };

  useOnClickOutside<HTMLDivElement>(popUpWrapperRef, close);

  return (
    <div className={cn(css.toLoginPopup, css[`${className}`])} data-testid="popup-wrapper">
      <div className={css.overlay} onClick={close} data-testid="overlay"></div>
      <div className={css.popupInner} ref={popUpWrapperRef}>
        <div className={css.closeWrapper} onClick={close}>
          <Icon type="close" />
        </div>
        <div className={css.text}>{renderText()}</div>
        <div className={css.okBtn} onClick={onOkClick} data-testid="ok-btn">
          {translate('toLoginPopUp.okBtn')}
        </div>
        <div className={css.cancelBtn} onClick={close} data-testid="close-btn">
          {translate('toLoginPopUp.cancelBtn')}
        </div>
      </div>
    </div>
  );
};

export default PopUpToLogin;
